module.exports = __webpack_public_path__ + "2c9e803724e213b650e574a8c15c5302.jpg";